import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { useMemo, useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { useResponsiveBreakPoints } from '@restworld/utils-common';
import JobPositionCard from '../job-position-card';
import { CarouselNavigation } from '../../design-system';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function JobPositionCardCarousel(_ref) {
  var items = _ref.items,
      cardStyling = _ref.cardStyling,
      cardContainerStyling = _ref.cardContainerStyling,
      cardVariant = _ref.cardVariant;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isLargeDesktop = _useResponsiveBreakPo.isLargeDesktop,
      isTablet = _useResponsiveBreakPo.isTablet;

  var carouselRef = useRef(null);
  var itemsElement = useMemo(function () {
    return items.map(function (v, i) {
      return /*#__PURE__*/_jsx(CardContainerStyled, {
        cardContainerStyling: cardContainerStyling,
        children: /*#__PURE__*/_jsx(JobPositionCard, _objectSpread(_objectSpread({}, v), {}, {
          twStyle: cardStyling,
          cardVariant: cardVariant
        }), i)
      }, i);
    });
  }, [cardContainerStyling, cardStyling, cardVariant, items]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(AliceCarousel, {
      mouseTracking: true,
      disableButtonsControls: true,
      disableDotsControls: true,
      keyboardNavigation: false,
      touchTracking: true,
      ref: carouselRef,
      items: itemsElement,
      autoWidth: true,
      paddingRight: 8,
      controlsStrategy: "responsive"
    }), (isLargeDesktop ? itemsElement.length > 4 : isTablet ? itemsElement.length > 2 : itemsElement.length > 1) && /*#__PURE__*/_jsx(CarouselNavigation, {
      carouselRef: carouselRef
    })]
  });
}
export default JobPositionCardCarousel;

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card-carousel__Wrapper",
  componentId: "sc-11ljq5s-0"
})({
  "position": "relative",
  "width": "100%",
  "overflow": "hidden"
});

var CardContainerStyled = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-position-card-carousel__CardContainerStyled",
  componentId: "sc-11ljq5s-1"
})(function (_ref2) {
  var twStyle = _ref2.cardContainerStyling;
  return [{
    "marginRight": "0.5rem",
    "width": "20rem"
  }].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});